export default "__VITE_ASSET__c5d34e96__"